module.exports = __webpack_public_path__ + "img/offline.83fd61df.png";